import { render, staticRenderFns } from "./editText.vue?vue&type=template&id=67b2ebda&scoped=true&"
import script from "./editText.vue?vue&type=script&lang=js&"
export * from "./editText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b2ebda",
  null
  
)

export default component.exports